/* eslint-disable no-unreachable */
import React, { useEffect, useState } from "react";

import "./global/global.css";
import SideBar from "./global/components/SideBar";
import AddIcon from "./assets/addIcon.png";
import LeftArrowKey from "./assets/LeftArrowKey.png";
import EyeIcon from "./assets/eyeIcon.png";
import BellIcon from "./assets/bellIcon.png";
import useWindowSize from "./global/hooks/WindowResizer";
import MobileViewHeader from "./global/components/MobileViewHeader";

const mockData = [
  {
    name: "AnandRam",
    address: "Brockport, NY",
    email: "vgts@gmail.com",
    phoneNumber: "(555) 555-1234",
    phoneCampaign: "Sent",
    emailCampaign: "Sent",
    snailMailCampaign: "Sent",
  },
  {
    name: "AnandRam",
    address: "Brockport, NY",
    email: "vgts@gmail.com",
    phoneNumber: "(555) 555-1234",
    phoneCampaign: "Sent",
    emailCampaign: "Sent",
    snailMailCampaign: "Sent",
  },
  {
    name: "AnandRam",
    address: "Brockport, NY",
    email: "vgts@gmail.com",
    phoneNumber: "(555) 555-1234",
    phoneCampaign: "Sent",
    emailCampaign: "Sent",
    snailMailCampaign: "Sent",
  },
  {
    name: "AnandRam",
    address: "Brockport, NY",
    email: "vgts@gmail.com",
    phoneNumber: "(555) 555-1234",
    phoneCampaign: "Sent",
    emailCampaign: "Sent",
    snailMailCampaign: "Sent",
  },
  {
    name: "AnandRam",
    address: "Brockport, NY",
    email: "vgts@gmail.com",
    phoneNumber: "(555) 555-1234",
    phoneCampaign: "Sent",
    emailCampaign: "Sent",
    snailMailCampaign: "Sent",
  },
];

const CallList = () => {
  const [callList, setCallList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Track campaign selections: { [rowIdx]: { phone: bool, email: bool, snail: bool } }
  const [campaignSelections, setCampaignSelections] = useState({});

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const isMobileView = useWindowSize();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/call-list`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch call list");
        const data = await response.json();
        setCallList(data.call_list || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Toggle a specific campaign type for a row
  const handleCheckboxChange = (rowIdx, type) => {
    setCampaignSelections((prev) => ({
      ...prev,
      [rowIdx]: {
        ...prev[rowIdx],
        [type]: !prev[rowIdx]?.[type],
      },
    }));
  };

  // At least one campaign type checked in any row
  const isAnyChecked = Object.values(campaignSelections).some(
    (row) => row && (row.phone || row.email || row.snail)
  );

  if (loading) {
    return (
      <div className="call-list-root">
        {/* {!isMobileView && <SideBar />} */}
        <div className="call-list-container">
          {/* {!isMobileView && (
            <div className="call-list-header">
              <div className="call-list-header-left">
                <img
                  src={LeftArrowKey}
                  alt="left-arrow-key"
                  className="cl-left-arrow-key"
                />
              </div>
              <div className="call-list-header-right">
                <img src={BellIcon} alt="belli" className="belli" />
              </div>
            </div>
          )} */}
          {/* {isMobileView && <MobileViewHeader />} */}
          <div className="call-list-heading">
            <div className="lc">
              <h3 className="cl-rh">Call list</h3>
              <p className="cl-rh-sub">
                Audit the complete history of fund requests and updates.
              </p>
            </div>
            <div className="rc">
              <p className="stc">START CAMPAIGN</p>
            </div>
          </div>
          <div className="call-list-table">
            <p className="loading">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="call-list-root">
        {/* {!isMobileView && <SideBar />} */}
        <div className="call-list-container">
          <div className="call-list-header">
            <div className="call-list-header-left">
              <img
                src={LeftArrowKey}
                alt="left-arrow-key"
                className="cl-left-arrow-key"
              />
            </div>
            <div className="call-list-header-right">
              <img src={BellIcon} alt="belli" className="belli" />
            </div>
          </div>
          <div className="call-list-heading">
            <div className="lc">
              <h3 className="cl-rh">Call list</h3>
              <p className="cl-rh-sub">
                Audit the complete history of fund requests and updates.
              </p>
            </div>
            <div className="rc">
              <p className="stc">START CAMPAIGN</p>
            </div>
          </div>
          <div className="call-list-table">
            <p className="error">Error: {error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="call-list-root">
      {/* {!isMobileView && <SideBar />} */}
      <div className="call-list-container">
        {/* {!isMobileView && (
          <div className="call-list-header">
            <div className="call-list-header-left">
              <img
                src={LeftArrowKey}
                alt="left-arrow-key"
                className="cl-left-arrow-key"
              />
            </div>
            <div className="call-list-header-right">
              <img src={BellIcon} alt="belli" className="belli" />
            </div>
          </div>
        )} */}

        {/* {isMobileView && <MobileViewHeader />} */}
        <div className="call-list-heading">
          <div className="lc">
            <h3 className="cl-rh">Call list</h3>
            <p className="cl-rh-sub">
              Audit the complete history of fund requests and updates.
            </p>
          </div>
          <div className="rc">
            <p className="stc">START CAMPAIGN</p>
          </div>
        </div>

        <div className="call-list-table">
          <div className="cl-table-container">
            <table className="cl-styled-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Phone Campaign</th>
                  <th>Email Campaign</th>
                  <th>Snail Mail Campaign</th>
                </tr>
              </thead>

              <tbody>
                {callList.map((call, idx) => (
                  <tr key={idx}>
                    <td>{call.name}</td>
                    <td>{call.address}</td>
                    <td>{call.email}</td>
                    <td>{call.phoneNumber}</td>
                    <td>
                      {/* <span className="status-badge">{call.phoneCampaign}</span> */}
                      <input
                        type="checkbox"
                        checked={!!campaignSelections[idx]?.phone}
                        onChange={() => handleCheckboxChange(idx, "phone")}
                        className="cl-checkBox"
                      />
                    </td>
                    <td>
                      {/* <span className="status-badge">{call.emailCampaign}</span> */}
                      <input
                        type="checkbox"
                        checked={!!campaignSelections[idx]?.email}
                        onChange={() => handleCheckboxChange(idx, "email")}
                        className="cl-checkBox"
                      />
                    </td>
                    <td>
                      {/* <span className="status-badge">
                        {call.snailMailCampaign}
                      </span> */}
                      <input
                        type="checkbox"
                        checked={!!campaignSelections[idx]?.snail}
                        onChange={() => handleCheckboxChange(idx, "snail")}
                        className="cl-checkBox"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallList;
